import { render, staticRenderFns } from "./CartDeliveryFee.vue?vue&type=template&id=6825c5a3&"
import script from "./CartDeliveryFee.vue?vue&type=script&lang=js&"
export * from "./CartDeliveryFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports